export default "__VITE_ASSET__DcumhWgB__"